import * as angular from 'angular';
import template from './serialConverterConfig.tpl.html';

export default angular.module('aps.controller.serialConverterConfig', [])
  .directive('apsSerialConverterConfig', (): angular.IDirective => {
    return {
      restrict: 'E',
      template: template
    };
  })
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/equipment/serialConverterConfig.directive.ts